import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "YardPage",

	metaInfo: { title: "Yard" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Drivers",
				icon: "person",
				to: { name: "yardDrivers" }
			},
			{
				title: "Hub",
				icon: "dashboard",
				to: { name: "yardHub" }
			},
			{
				title: "Reports",
				icon: "pie_chart",
				to: { name: "yardReports" }
			},
			{
				title: "Schedules",
				icon: "date_range",
				to: { name: "yardSchedules" }
			},
			{
				title: "Trip Cost Estimator",
				icon: "attach_money",
				to: { name: "yardTripCostEstimator" }
			},
			{
				title: "Trips",
				icon: "directions",
				to: { name: "yardTrips" }
			},
			{
				title: "Trucks",
				icon: "local_shipping",
				to: { name: "yardTrucks" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
